import React from "react";
import { FiPlus,FiMail } from "react-icons/fi";

import Tooltip from "../tooltip/Tooltip";
import { useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ReplayButton = ({
  id,
  title,
  handleUpdate,
  handleModalOpen,
  isCheck,
  service,
  career,
  slider,
  count,
  isLoading,
  setIsLoading,
  blog,
  project,
  staff,
  category,
  reference,
  department,
  DepartmentsContact,
  name,
  type, // Nouvelle prop "type"
  parent,
  children,
  adminprevilegesList

}) => {
  const { t } = useTranslation();

  const location = useLocation();
  
    return (
      <>
       
         
               {(adminprevilegesList?.includes("reply_quotes")) && ( 

                <button
                  disabled={isCheck?.length > 0}
                  onClick={() => handleUpdate(id)}
                  className="p-2 cursor-pointer text-gray-400 hover:text-orange-600 focus:outline-none"
                >
                  <Tooltip
                    id="edit"
                    Icon={FiMail}
                    title={t("Replay")}
                    bgColor="#ff5a1f"
                  />
                </button>
             )} 
            
    
      </>
    );
  }

;

export default ReplayButton;
